import React from "react";
import { useNavigate } from "react-router-dom";

const TrendingCard = ({ name, actual_price, selling_price, image }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/products");
  };


 
  return (
    <div
      onClick={handleClick}
      className="bg-white rounded-2xl shadow-md hover:shadow-xl transition-all duration-300 cursor-pointer overflow-hidden group border border-gray-100 flex flex-col h-full"
    >
      {/* Image Section */}
      <div className="relative h-48 md:h-52 w-full overflow-hidden bg-gray-50">
        <span className="absolute top-3 left-3 z-10 bg-pink-500 text-white text-[10px] uppercase font-bold px-2 py-1 rounded-full shadow">
          Trending
        </span>

        <img
          src={image}
          alt={name}
          className="w-full h-full object-contain p-2 transition-transform duration-500 group-hover:scale-110"
          onError={(e) => {
            e.target.src = "https://via.placeholder.com/400";
          }}
        />
      </div>

      {/* Content Section */}
      <div className="p-4 text-center mt-auto">
        <h2 className="text-sm font-semibold text-gray-800 line-clamp-2">
          {name}
        </h2>
        <div className="flex justify-center gap-2">
 <p className="text-pink-600 font-bold mt-1 text-lg line-through">
          ₹{actual_price}
        </p>
        <p className="text-pink-600 font-bold mt-1 text-lg">
          ₹{selling_price}
        </p>
        </div>
       
      </div>
    </div>
  );
};

export default TrendingCard;